/*
 * Public API Surface of capiche-ui
 */

export * from './lib/constants';

export * from './lib/services/font-preference/font-preference.service';
export * from './lib/services/student-display.service';
export * from './lib/capiche-ui.config';

export * from './lib/components/header/header.component';
export * from './lib/components/footer/footer.component';
export * from './lib/components/current-user/current-user.component';
export * from './lib/components/version-string/version-string.component';
export * from './lib/components/version-string/capiche-version.config';
export * from './lib/components/color-palette/color-palette.component';
export * from './lib/components/color-palette/color-palette.service';

export * from './lib/components/paragraph/paragraph.component';
export * from './lib/components/sentence/sentence.component';
export * from './lib/components/word/word.component';
export * from './lib/components/suggestion/suggestion.component';
